import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import colors from '../../themes/main-colors';
import BroadcastCommunicationBanner from '../BroadcastCommunication/BroadcastCommunicationBanner';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';

const getBackgroundColor = (color: string | undefined) => {
  switch (color) {
    case 'Blue':
      return colors.riverBlue;
    case 'Grey':
      return colors.cloudGrey2;
    case 'Yellow':
      return colors.lightYellow;
    default:
      return colors.cloudGrey2;
  }
};

const useStyles = makeStyles((theme: Theme) => ({
  outlinedWarning: {
    '& .MuiCollapse-container': {
      backgroundColor: ({ backgroundColor }: IProps) =>
        getBackgroundColor(backgroundColor),
      background: colors.lightGray2,
      borderRadius: 6,
      borderWidth: theme.spacing(0.125),
      borderStyle: 'solid',
      borderColor: colors.white,
      width: '100%',
    },
    '& .MuiAlert-root': {
      padding: 0,
      margin: theme.spacing(2.5, 3.75, 1.25, 3.75),
    },
    '& .MuiAlert-icon': {
      color: colors.noirBlur,
      padding: theme.spacing(0, 0),
      fontSize: theme.spacing(2.5),
    },
    '& .MuiAlert-outlinedWarning': {
      border: 'none',
      paddingTop: theme.spacing(1.25),
      background: 'inherit',
      '& .MuiSvgIcon-root': {
        fill: colors.noirBlur,
      },
    },
    '& .MuiAlert-outlinedInfo': {
      border: 'none',
      paddingTop: theme.spacing(1.25),
      background: 'inherit',
      '& .MuiSvgIcon-root': {
        fill: colors.noirBlur,
      },
    },
    '& .MuiIconButton-sizeSmall': {
      padding: theme.spacing(0, 0.375),
    },
    '& .MuiAlert-message': {
      padding: theme.spacing(0, 0),
      '& .MuiAlertTitle-root': {
        color: colors.darkGray2,
        fontSize: theme.spacing(2.25),
        fontWeight: 400,
        lineHeight: theme.typography.pxToRem(18),
        marginTop: 0,
      },
      '& p': {
        fontSize: theme.spacing(2.25),
        color: colors.darkGray2,
        lineHeight: theme.typography.pxToRem(18),
      },
    },
    '& .MuiAlert-action': {
      alignItems: 'flex-start',
      color: colors.darkGray2,
      opacity: 0.87,
    },
    '& .MuiCollapse-entered': {
      margin: theme.spacing(2.5, 0),
    },
  },
}));
interface IProps {
  message: any;
  title?: string;
  backgroundColor?: string;
  hideTheCloseAction?: boolean | null | undefined;
  severity?: 'warning' | 'information' | 'none';
}
export default (props: IProps) => {
  const classes = useStyles(props);

  const iconType = props?.severity
    ? props?.severity?.includes('info')
      ? 'info'
      : props?.severity
    : 'none';

  const getIcon = (severityType: string | undefined) => {
    switch (severityType) {
      case 'info':
        return <InfoIcon sx={{ color: colors.noirBlur }} />;
      case 'warning':
        return <WarningIcon sx={{ color: colors.noirBlur }} />;
      case 'none':
        return false;
      default:
        return false;
    }
  };

  return (
    <div className={classes.outlinedWarning}>
      <BroadcastCommunicationBanner
        severity={iconType as any}
        hideTheCloseAction={props?.hideTheCloseAction}
        messageBody={props.message}
        variant="outlined"
        icon={getIcon(iconType)}
      />
    </div>
  );
};
